import Vue from 'vue'
import Roadmap from './Roadmap.vue'
import BootstrapVue from 'bootstrap-vue'

import 'bootswatch/dist/spacelab/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
  render: h => h(Roadmap),
}).$mount('#app')
